module.exports = __webpack_public_path__ + "img/onboarding.485a82cc.webp";